import "@fortawesome/fontawesome-free/css/all.min.css";
import './App.css';
import ChatArea from './ChatArea';
import { useState, useRef, useEffect } from 'react';
import HiddenAudioPlayer from './AudioPlayer';
import { Route, Routes, useNavigate } from 'react-router-dom';
import Home from './Home';
import ChatComponent from './ChatComponent'
import Login from "./Components/Login";
import { BOT_1, TOKEN } from "./Constants/constants";

// let chatbotSocket = new WebSocket("wss://lexbot.diyoraai.uz/ws/legal_advice");
let chatbotSocket = new WebSocket("wss://auditaibot.soof.uz/ws/audit");


function App() {
  const navigate = useNavigate()
  const [botUrl, setBotUrl] = useState(BOT_1)

  return (
    <>
      <Routes>
        {
          !TOKEN ? (
            <>
              <Route path='/login' element={<Login />} />
              <Route path='/' element={<Home botUrl={botUrl} setBotUrl={setBotUrl} />} />
            </>
          ) : (
            <>
              <Route path='/' element={<Home botUrl={botUrl} setBotUrl={setBotUrl} />} />
              <Route path={'/chat'} element={<ChatComponent botUrl={botUrl} />} />
            </>
          )
        }

      </Routes>
    </>
  );

}
export default App;
